import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

// fontawesome is loaded in main.ts, so vuetify docs aren't followed completely

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#185B92',
        secondary: '#FFF493',
        accent: '#EFEFEF',
        subheading: '#262626',
        error: '#FF726B',
        info: '#9AD1F9',
        initial: '#FFFFFF',
        success: '#85CD4D',
        warning: '#FFC107',
        approved: '#789fda',
        submitted: '#b3b3b3',
        notactive: '#eaeaea',
        open: '#5ba6e3',
        hold: '#ffb505',
        complete: '#86cd4d',
        denied: '#f96767',
        dnc: '#f76c5e'
      }
    }
  },
  icons: {
    iconfont: 'faSvg', // font-awesome 5
    // https://github.com/vuetifyjs/vuetify/issues/12625 -- font-awesome 5 svg icons must be manually registered explicitly and used with the $vuetify.icons.name syntax.
    values: {
      alert: {
        component: FontAwesomeIcon,
        props: {
          icon: ['fas', 'exclamation-circle']
        }
      },
      ellipsisV: {
        component: FontAwesomeIcon,
        props: {
          icon: ['fas', 'ellipsis-v']
        }
      },
      plus: {
        component: FontAwesomeIcon,
        props: {
          icon: ['fas', 'plus']
        }
      },
      print: {
        component: FontAwesomeIcon,
        props: {
          icon: ['fas', 'print']
        }
      },
      file: {
        component: FontAwesomeIcon,
        props: {
          icon: ['fas', 'file']
        }
      },
      circle: {
        component: FontAwesomeIcon,
        props: {
          icon: ['fas', 'circle']
        }
      },
      chevronLeft: {
        component: FontAwesomeIcon,
        props: {
          icon: ['fas', 'chevron-left']
        }
      },
      chevronRight: {
        component: FontAwesomeIcon,
        props: {
          icon: ['fas', 'chevron-left']
        }
      }
    }
  }
});
